<script setup>
import CFBanner from '@/ui/Banner/CFBanner.vue';
</script>

<template>
    <CFBanner>
        {{ $t('banner.locked_team_notice') }}
    </CFBanner>
</template>
